/* oxlint-disable */
'use client';

import Link from 'next/link';

import { FooterLinkSection, FooterLinksProps } from '@/features/cms/interface';
import { core as cmsCore } from '@/features/cms/localization/core';

function FooterLinks({ sections }: FooterLinksProps) {
  const displaySections = sections.length > 0 ? sections : cmsCore.footer.sections;

  return (
    <>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {displaySections.map((section) => {
          return (
            <div key={section.title} className="mb-8 lg:mb-0">
              <h4 className="info-header">{section.title}</h4>
              <ul className="list-secondary-gap-2">
                {section.links.map((link) => {
                  return (
                    <li key={link.href}>
                      {link.external ? (
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:underline"
                        >
                          {link.title}
                        </a>
                      ) : (
                        <Link prefetch={false} href={link.href}>
                          {link.title}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </>
  );
}

export { FooterLinks };
